import React from 'react';
import { useApp } from '../../../../context/app';
import { GerenciarPerfilUsuarios } from './GerenciarPerfilUsuarios';
import getListaPerfil from './getListaPerfil';
import { IncluirListaUsuario } from './IncluirListaUsuario';
import { IncluirPerfilUsuario } from './IncluirPerfilUsuario';

export const PerfilUsuarios = () => {
  const { renderIncludeScreen, renderIncludePerfilOrLista } = useApp();

  const { selectPerfil } = getListaPerfil();

  return renderIncludeScreen ? (
    !!renderIncludePerfilOrLista ? (
      <IncluirListaUsuario onSelectPerfil={selectPerfil} />
    ) : (
      <IncluirPerfilUsuario />
    )
  ) : (
    <GerenciarPerfilUsuarios />
  );
};
